import type { ReactNode } from 'react';
import React from 'react';

import { DrawerHeaderBar } from '@/shared/ui';

import { GX_TEXT } from '@/config/colors';

import AddApp from '@/assets/icons/AddApp';

export const DrawerHeader = ({
  before,
  title,
  buttons
}: {
  before?: ReactNode;
  title: string;
  buttons: ReactNode;
}) => (
  <DrawerHeaderBar
    actions={buttons}
    before={before}
    icon={
      <AddApp
        fill={GX_TEXT}
        sx={{
          width: '32px',
          height: '32px'
        }}
      />
    }
    title={title}
  />
);
